






























import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { IImageVariants } from '~/assets/interfaces/images'
import { IStyle } from '~/assets/interfaces/classes'

@Component
export default class ComponentImage extends Vue {
  @Prop({
    type: [Object, String, Array],
    default: () => {},
  })
  private image!: IImageVariants | string

  @Prop({
    type: [Object, String, Array],
    default: () => {},
  })
  private imageZoom!: IImageVariants | string

  @Prop({ type: String, default: '' }) private alt!: string
  @Prop({ type: String, default: '' }) private title!: string
  @Prop({ type: Boolean, default: false }) private cover!: boolean
  @Prop({ type: Boolean, default: true }) private lazyload!: boolean
  @Prop({ type: Boolean, default: false }) private multiply!: boolean
  @Prop({ type: Boolean, default: false }) private absolute!: boolean
  @Prop({ type: Boolean, default: false }) private canZoom!: boolean
  @Prop({ type: [String, Number], default: '' }) private aspectRatio!:
    | string
    | number

  private $style!: IStyle
  private zoomed = false

  private get classImage() {
    return {
      [this.$style.image]: true,
      [this.$style.cover]: this.cover,
      [this.$style.multiply]: this.multiply,
      [this.$style.canZoom]: this.canZoom,
    }
  }

  private get classImageZoom() {
    return {
      [this.$style.zoom]: true,
    }
  }

  private get styleImageWrapper() {
    return this.aspectRatio
      ? {
          aspectRatio: this.aspectRatio,
        }
      : {}
  }

  private get classImageWrapper() {
    return {
      [this.$style.imageWrapper]: true,
      [this.$style.zoomOnHover]: this.canZoom,
      [this.$style.zoomed]: this.zoomed,
      [this.$style.cover]: this.cover && !this.absolute,
      [this.$style.absolute]: this.absolute,
    }
  }

  private get imageRender(): string {
    if (typeof this.image === 'string') {
      return this.image
    }
    return Object.entries(this.image)
      .map(([key, value]) => `${value} ${key}`)
      .join(', ')
  }

  private get imageZoomRender(): string {
    if (typeof this.imageZoom === 'string') {
      return this.imageZoom
    }
    const keys = Object.keys(this.imageZoom)
    const lastKey = keys.pop()
    if (lastKey) {
      return this.imageZoom[lastKey]
    }
    return ''
  }

  private zoom() {
    if (this.canZoom) {
      this.zoomed = true
    }
  }

  private touchzoom(event: MouseEvent) {
    if (!this.canZoom) return
    this.move(event)
    this.zoomed = !this.zoomed
  }

  private unzoom() {
    if (this.canZoom) {
      this.zoomed = false
    }
  }

  private scaleFactor = 1

  private move(event: MouseEvent) {
    if (!this.canZoom || !this.zoomed) return
    const el = this.$el as HTMLElement
    const offset = el.getBoundingClientRect()
    const zoom = this.$refs.zoom as HTMLElement
    const normal = this.$refs.normal as HTMLElement
    const relativeX = event.clientX - offset.left
    const relativeY = event.clientY - offset.top

    const normalFactorX = relativeX / normal.offsetWidth
    const normalFactorY = relativeY / normal.offsetHeight

    const x =
      normalFactorX * (zoom.offsetWidth * this.scaleFactor - normal.offsetWidth)
    const y =
      normalFactorY *
      (zoom.offsetHeight * this.scaleFactor - normal.offsetHeight)
    zoom.style.left = -x + 'px'
    zoom.style.top = -y + 'px'
  }
}
